<!--  -->
<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex flex-wrap">
				<el-input v-model.trim="routeName" class="w190" size="small" placeholder="路线名称" @keyup.enter.native="handleSearch"
					maxlength="16" clearable>
				</el-input>
				<el-date-picker class="ml10"
					format="yyyy-MM-dd"
					value-format="yyyy-MM-dd"
					size="small" v-model="planDate" type="daterange" :editable="false" :clearable="false" @change="handleSearch()"
					range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
				<el-input v-model.trim="licensePlate" class="w190 ml10" size="small" placeholder="车辆" @keyup.enter.native="handleSearch"
					maxlength="11" clearable>
				</el-input>

				<el-select v-model="planStatus" class="w190 ml10" size="small" placeholder="请选择执行状态" @change="handleSearch()"
					clearable>
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch()" alt="">

			</div>
			<div class="operation-box" v-if="isEdit">

				<img class="icon-img ml7" src="@/assets/images/merge.png" @click="handleMerge" title="合并" alt="">
					<img class="icon-img ml7" src="@/assets/images/disable.png" @click="updateStatusRow('N')" title="停用"
					alt="">
				<img class="icon-img ml7" src="@/assets/images/enable.png" @click="updateStatusRow('Y')" title="启用"
					alt="">
				<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="">
				<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="">
			</div>
		</div>
		<div class="table-container">
			<el-table ref="multipleTable" v-if="tableData.length>0" v-el-table-infinite-scroll="tableLoad"
				:data="tableData" :height="height" :cell-style="cellStyle" :row-class-name="tabRowClassName"
				:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
				:row-key="getRowKey"
				@selection-change="handleSelectionChange" border style="width: 100%" @cell-click="editRow" >
				<el-table-column type="selection" width="50" :reserve-selection="true" align="center">
				</el-table-column>
				<el-table-column prop="planCode" width="180" label="计划编号" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="planDate" width="120" label="计划日期" :show-overflow-tooltip="true" fixed sortable>
				</el-table-column>
				<el-table-column prop="week" width="100" label="周" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="routeName" width="120" label="路线名称" :show-overflow-tooltip="true" fixed sortable>
				</el-table-column>
				<el-table-column prop="licensePlate" width="120" label="车辆" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="mainUserName" width="120" label="主路线员" :show-overflow-tooltip="true" fixed sortable>
				</el-table-column>
				<el-table-column prop="secUserName" width="120" label="副路线员" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="planStatus" width="120" label="执行状态" :show-overflow-tooltip="true" sortable>
					<template slot-scope="scope">
						{{planStatusStr[scope.row.planStatus]}}
					</template>
				</el-table-column>
				<el-table-column prop="roundStatus" width="100" label="状态" :show-overflow-tooltip="true" sortable></el-table-column>
				<el-table-column prop="tempFlag" width="120" label="临时计划" :show-overflow-tooltip="true" sortable>
					<template slot-scope="scope">
						{{ scope.row.tempFlag == 1 ? '是' : '否' }}
					</template>
				</el-table-column>
				<el-table-column prop="drawOutTime" width="160" label="出车时间" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="returnTime" width="160" label="日结时间" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="groupName" min-width="300" label="组织部门" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column label="操作" width="110"  fixed="right">
				<template slot-scope="scope" v-if="isEdit">
	                    <img class="icon-img ml7" v-if="scope.row.cancelFlag==1" src="@/assets/images/revoke.png" @click="handleRecall(scope.row)" title="撤销日结" alt="">
	                    <img class="icon-img ml7" v-if="scope.row.planStatus==1||scope.row.planStatus==2" src="@/assets/images/return.png" @click="handleReturn(scope.row)" title="强制日结" alt="">
				</template>
				</el-table-column>
			</el-table>
			<el-empty v-else :style="{height:height+'px'}" description="暂无数据"></el-empty>
			<div class="flex flex-between search-container">
					<div class="totalPage">
						当前第<span class="page-active">{{currentNo}}</span>页，共<span class="page-active">{{totalCount}}</span>条数据，共<span class="page-active">{{totalPage}}</span>页
					</div>
				<img class="icon-img" style="vertical-align: middle;" src="@/assets/images/down.png" @click="download" title="导出" alt="">
			</div>
		</div>
		<tourEdit ref="tourEdit" @getList="handleSearch"></tourEdit>
		<addRoute ref="addRoute" @getList="handleSearch"></addRoute>
		<mergeMerTour ref="mergeMerTour" @getList="handleSearch"></mergeMerTour>
	</div>
</template>

<script>
	import addRoute from './components/add-route.vue'
	import tourEdit from './components/tour-edit.vue'
	import mergeMerTour from './components/merge-tour.vue'
	import {dateFormat} from '@/utils/common'
	import { hasPermission } from '@/utils/permission'
	import { debounce } from '@/utils/debounce'
	export default {
		name:'tour',
		components: {
			tourEdit,
			mergeMerTour,
			addRoute
		},
		data() {
			return {
				routeName: '',
				planDate: [],
				licensePlate: '',
				planStatus: '',
				tableData: [],
				multipleTable: [],
				planStatusStr: {
					0: '未开始',
					1: '已出车',
					2: '已回库',
					3: '已确认'
				},
				options: [
					{
						value: '0',
						label: '未开始'
					}, {
						value: '1',
						label: '已出车'
					}, {
						value: '2',
						label: '已回库'
					}, {
						value: '3',
						label: '已确认'
					}
				],
				selectAttribute: "",
				pageNo: 1,
				pageSize: 40,
				height: 500,
				infiniteFlag: false,
				isEdit:false,
				totalPage:"",
				totalCount:"",
				currentNo:"",
			}
		},
		created() {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
			this.planDate=[dateFormat(start), dateFormat(end)]
			this.getList()
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		mounted() {
			let height = this.$refs.tableHeight.offsetHeight;
			this.height = window.innerHeight - 130 - height;
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},


			// 获取列表
			getList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"roundPlanList",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							licensePlate: that.licensePlate,
							planDateStart: that.planDate ? that.planDate[0] : '',
							planDateEnd: that.planDate ? that.planDate[1] : '',
							routeName: that.routeName,
							planStatus: that.planStatus,
						}
					)
					.then((res) => {
						if (res) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
							if(type == 'scroll') {
								that.tableData = that.tableData.concat(res.data.list);
								that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
							}else {
								if (res.data && res.data.list.length > 0) {
									that.tableData = res.data.list;
									that.totalPage=res.data.totalPage
									that.totalCount=res.data.totalCount
									that.currentNo = res.data.pageNo

								} else {
									that.titles = []
									that.tableData = []
									that.totalPage=0
									that.totalCount=0
									that.currentNo = 0
								}

							}
						}
					})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),
			// 搜索
			handleSearch() {
				if(this.tableData.length > 0){
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
				this.infiniteFlag = false;
				this.pageNo = 1;
				this.$nextTick(() => {
					this.getList();
				})
			},
			// el-table刷新数据，保留原数据继续选中状态
			getRowKey(row) {
				return row.planId
			},
			// 新增
			handleEdit() {
				this.$refs.addRoute.init()
			},
			//批量sku调整属性
			handleSelect(val) {
				if (val == 1 || val == 2) {
					this.$refs.batch.init(val, this.multipleTable)
				}
			},
			// 合并路线
			handleMerge() {
				this.$refs.mergeMerTour.init()
			},
			// 查看/编辑
			editRow(row, column, cell, event) {
				if (column.label == '计划日期') {
					this.$refs.tourEdit.init(row)
				} else if(column.label != '计划日期'&&column.label != '操作') {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleTable = val;
			},
			// 撤回
			handleRecall(row) {
				let that = this;
				// if (that.multipleTable.length <= 0) {
				// 		that.$message.error('请先选择!');
				// 		return
				// 	}
				that.$confirm('确认要撤销选中的巡回计划的日结信息吗，已生成的巡回日报将一并撤销？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					//
					// let planIds = []
					// that.multipleTable.forEach(item => {
					// 	planIds.push(item.planId)
					// });
					that.$request.post(
							"planCancel",
							true, {
								planId: row.planId,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("撤销成功！");
								that.handleSearch()
							}
						})
				}).catch(() => {});
			},
			// 强制回车
			handleReturn(row){
				let that = this;
				that.$confirm('确认要强制日结吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
				that.$request.post(
						"roundPlanBackCar",
						true, {
							planId: row.planId,
						}
					)
					.then((res) => {
						if (res) {
							that.$message.success("强制日结成功！");
							that.handleSearch()
						}
					})
					}).catch(() => {});
			},
			// 状态
			updateStatusRow(status) {
				let that = this;
				if (that.multipleTable.length <= 0) {
						that.$message.error('请先选择!');
						return
					}
				let msg = '确认要' + (status == 'Y' ? '启用' : '停用') + '选中的巡回计划吗？'
				that.$confirm(msg, {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(() => {
					let planIds = []
					that.multipleTable.forEach(item => {
						planIds.push(item.planId)
					});
					that.$request.post(
							"planUpdateStatus",
							true, {
								planIds: planIds,
								roundStatus: status
							}
						)
						.then((res) => {
							if (res) {
								// 0:正常;1:停用
								that.$message.success(status == 'Y' ? "已启用！" : "已停用！");
								that.handleSearch()
							}
						})
				}).catch(() => {});


			},
			// 删除
			deleteRow() {
				let that = this;
				if (that.multipleTable.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				let planIds = []
				that.multipleTable.forEach(item => {
					planIds.push(item.planId)
				});
				that.$confirm('是否确认删除？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					that.$request.post(
							"roundPlanDelete",
							true, {
								planIds: planIds,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("删除成功！");
								that.handleSearch()
							}
						})
				}).catch(() => {});
			},
			// 导出
			download() {
				let that = this;
				// if (that.multipleTable.length <= 0) {
				// 	this.$message.error('请先选择!');
				// 	return
				// }
				let planIds = []
				that.multipleTable.forEach(item => {
					planIds.push(item.planId)
				});
				that.$request.post(
						"roundPlanExport",
						true, {
							pageNo: 1,
							pageSize: 50000,
							planIds: planIds,
							licensePlate: that.licensePlate,
							planDateStart: that.planDate ? that.planDate[0] : '',
							planDateEnd: that.planDate ? that.planDate[1] : '',
							routeName: that.routeName,
							planStatus: that.planStatus,
						}
					)
					.then((res) => {
						if (res) {
							let downloadURL = res.data
							const linkNode = document.createElement('a');
							linkNode.style.display = 'none';
							linkNode.href = downloadURL;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						}
					})
			},
		},
	}

</script>

<style lang='scss' scoped>
	.container {
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;
		// padding-bottom: 20px;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
	}

	.operation-box {
		min-width: 110px;
	}

	.w190 {
		width: 150px !important;
	}

</style>
